import React from 'react';
import { PhoneCallIcon } from 'lucide-react';
export function BrandLogo() {
  return <div className="flex items-center gap-3" data-id="element-374" data-mp="mip7rx7c10zf">
      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent text-on-accent" data-id="element-375" data-mp="mkjpl2nb4cza">
        <PhoneCallIcon className="h-5 w-5" strokeWidth={2.2} aria-hidden data-id="element-376" data-mp="7vvzhbw8cvgq" />
      </span>
      <div className="leading-tight" data-id="element-377" data-mp="ctp3bya29ddu">
        <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-subtle" data-id="element-378" data-mp="10iqhm25krir1">MVP Funding</p>
        <p className="whitespace-nowrap font-display text-lg font-bold tracking-tight text-accent" data-id="element-379" data-mp="15htako8a5yin">Calls Insight Hub</p>
      </div>
    </div>;
}